import { memo } from "react";

// Helpers
import { useTranslate } from "helpers";

// Servisni sloj
import { initialDataWithPagination } from "services/api/consts";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

import { FLEET_VEHICLE_SERVICE_SEARCH_COLUMNS } from "./consts";
import { ServiceSearchResultsProps } from "./types";

const ServiceSearchResults: React.FC<ServiceSearchResultsProps> = (props) => {
  const {
    searchResults,
    isLoading,
    onRowClick,
    onPaginationChange,
    onDeleteClick,
    showVehicle,
    onVehicleClick,
  } = props;

  const { t } = useTranslate();

  return (
    <TableSearch
      columns={FLEET_VEHICLE_SERVICE_SEARCH_COLUMNS(t, onDeleteClick, showVehicle, onVehicleClick)}
      data={searchResults.data}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      selectableRows={false}
      isLoading={isLoading}
      onRowClick={onRowClick}
      onPaginationChange={onPaginationChange}
    />
  );
};

export default memo(ServiceSearchResults);
